import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { configurationProfileSchema } from '../schemas/configuration-profile.schema';

/**
 * Requests the Configuration Profiles associated with specific Vehicle Groups
 * @param ids The vehicle group IDs for the vehicle whose Configuration Profiles are being requested
 * @returns The Configuration Profiles
 */
export function getConfigurationProfilesVehicleGroups(
  this: unknown,
  ids: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          fleetEnvironment.resolve(this).configurationProfilesVehicleGroupsUrl
        }?vehicleGroupIds=${ids.toString()}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(configurationProfileSchema),
      })
    )
  );
}
